import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
  Switch,
  Button,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

interface PostClosingActionModalProps {
  title: string;
  fieldKey: string;
  loans: any[];
  onConfirm: (value: boolean) => void;
  onClose: () => void;
}

export const PostClosingActionModal: React.FC<PostClosingActionModalProps> = ({
  title,
  loans,
  onConfirm,
  onClose,
}) => {
  const [value, setValue] = useState<boolean>(true);

  const handleConfirm = () => {
    onConfirm(value);
  };

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle disableTypography style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">{title}</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box mb={3} display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle1">Select Value:</Typography>
          <Box display="flex" alignItems="center">
            <Typography variant="body2">No</Typography>
            <Switch
              checked={value}
              onChange={() => setValue(!value)}
              color="primary"
              inputProps={{ 'aria-label': 'boolean switch' }}
            />
            <Typography variant="body2">Yes</Typography>
          </Box>
        </Box>

        <Box>
          <Typography variant="subtitle1">Loans to update:</Typography>
          <List dense>
            {loans.map((loan, index) => (
              <ListItem key={index} divider>
                <ListItemText primary={`Loan ID: ${loan}`} />
              </ListItem>
            ))}
          </List>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="default">
          Cancel
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
